<template src="./template.html"></template>


<script>
    /* eslint-disable no-console,no-restricted-syntax, no-param-reassign */
    import { mapGetters } from 'vuex';
    import DeleteBtn from '../../atoms/button/DeleteBtn';
    import DeleteDialog from '../../atoms/dialog/Delete';
    import RowTemplate from '../order/RowTemplate';
    import {
        ORDER_STATUS_UPDATE, ORDER_COMMENT_UPDATE,
        DELETE_ORDER, DELETE_ORDER_PANEL,
        EXPORT_ORDERS,
        FETCH_BUILDINGS,
        FETCH_ORDERS, FETCH_WORDING, FETCH_ORDERS_BY_PAGE,
    } from '../../../store/types';
    import responseFormat from '../../../util/responseFormat';

    export default {
        name: 'Orders',
        data () {
            return {
                currentPage: 1,
                activeTab: 'first',
                loading: false,
                deleteMode: false,
                deletePanel: null,
                searchByName: '',
            };
        },
        components: { DeleteBtn, DeleteDialog, RowTemplate },
        computed: {
            ...mapGetters(['get_orders', 'get_suppliers', 'user_is_admin', 'user_is_supplier', 'get_wording']),
            orders () {
                return this.get_orders;
            },
            tableColumns () {
                const columns = [
                    { prop: 'id', label: 'ID', type: 'number', width: 80, editable: false },
                    { prop: 'customer', label: 'Benutzer', type: 'text', formatter: row => row.customer.name, sort: 2 },
                    { prop: 'total_amount', label: 'Total', type: 'text', rule: [{ required: true }], sort: 3 },
                    { prop: 'created_at', label: 'Erstellt', type: 'text', editable: false, rule: [] },
                    { prop: 'is_active', label: 'Operations', type: 'button', buttonText: 'Activate', action: this.activateOrder, formatter: row => (row.is_active ? 'Taken' : 'Reserved') },
                ];
                // Awdd column supplier only for admin
                if (this.user_is_admin) {
                    const supplier = { prop: 'supplier', label: 'Supplier', type: 'text', width: 150, formatter: row => row.supplier.supplier_name, sort: 1 };
                    columns.splice(1, 0, supplier);
                }

                return columns;
            },
        },
        created () {
            if (!this.orders) {
                this.loading = true;
                this.getOrders()
                    .then(() => {
                        this.$store.dispatch(FETCH_WORDING).then(() => {
                            this.loading = false;
                        });
                    });
            }
        },
        methods: {
            handlePaginationChange (e) {
                this.loading = true;
                const querySearch = `?page=${e}&name=${this.searchByName}`;
                return this.$store.dispatch(FETCH_ORDERS_BY_PAGE, querySearch).then(() => {
                    this.loading = false;
                });
            },
            updateComment ({ orderId, comment }) {
                const commentObject = { orderId, comment };
                this.$store.dispatch(ORDER_COMMENT_UPDATE, commentObject).then((resp) => {
                    this.$message.success(resp.message);
                }).catch((resp) => {
                    this.$message.error(responseFormat.getErrorMessage(resp));
                });
            },
            getOrders () {
                return this.$store.dispatch(FETCH_ORDERS);
            },
            handleStatusAction (rowIndex, orderId, status) {
                this.loading = true;
                const order = {
                    id: orderId,
                    status,
                };

                this.$store.dispatch(ORDER_STATUS_UPDATE, order).then((resp) => {
                    this.$message.success(resp.message);
                    this.$store.dispatch(FETCH_BUILDINGS);
                }).catch((resp) => {
                    this.$message.error(responseFormat.getErrorMessage(resp));
                }).then(() => {
                    this.loading = false;
                });
            },
            deleteOrder (orderId) {
                this.loading = true;

                this.$store.dispatch(DELETE_ORDER, orderId).then((resp) => {
                    this.$message.success(resp.message);
                }).catch((resp) => {
                    this.$message.error(responseFormat.getErrorMessage(resp));
                }).then(() => {
                    this.loading = false;
                });
            },
            deletePanelClickHandler (orderId) {
                this.deleteMode = true;
                this.deletePanel = orderId;
            },
            deleteOrderPanel () {
                this.deleteMode = false;
                this.loading = true;
                this.$store.dispatch(DELETE_ORDER_PANEL, this.deletePanel).then((resp) => {
                    if (resp.data.panels && resp.data.panels.length) {
                        this.$message.success(resp.message);
                        this.loading = false;
                    } else {
                        // still leave loading
                        this.loading = true;
                        this.deleteOrder(this.deletePanel.pivot.order_id);
                    }
                }).catch((resp) => {
                    this.$message.error(responseFormat.getErrorMessage(resp));
                    this.loading = false;
                });
            },
            handleRefreshClick () {
                this.handlePaginationChange(this.currentPage);
            },
            handleExportOrdersClick () {
                this.$store.dispatch(EXPORT_ORDERS, `?name=${this.searchByName}`);
            },
            getBuildingAddress (building) {
                return `${building.street} ${building.house_number}${building.suffix}`;
            },
            handleSearchOrderByName () {
                this.loading = true;
                this.$store.dispatch(FETCH_ORDERS, `?name=${this.searchByName}`)
                .then(() => {
                    this.loading = false;
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    .el-icon-arrow-down {
        font-size: 12px;
    }
    .demonstration {
        display: block;
        color: #8492a6;
        font-size: 14px;
        margin-bottom: 20px;
    }
    address {
        font-size: 14px;
        font-style: italic;
    }
    strong {
        font-weight: bold;
    }
    h3 {
        font-size: 16px;
    }
    .table-header {
        padding-bottom: 1rem;
        border-bottom: 1px solid #0000001a;
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }

    .panel-box {
        .gift-logo {
            width: 17px;
            height: 17px;
            display: inline-block;
            background: url('../../../assets/images/icons/gift-icon.svg');
        }
    }

    .wraped-tag{
        height: auto;
        padding: 10px;
        white-space: normal;
        line-height: 16px;
    }

    .comment-textarea{
        margin-bottom: 10px;
    }

</style>



// WEBPACK FOOTER //
// src/components/pages/order/Order.vue